import { TableColumn } from 'modules/shared-components/data-display/table/types';
import { Pagination } from 'api/types/httpsTypes';
import classNames from 'classnames';
import { formatTokenAmountCompact } from 'utils/FormatNumber';

export interface Follower {
  id: string;
  userName: string;
  returns: number;
}

export type ColumnProps = {
  pagination: Pagination;
  data: Follower[];
  errors?: any[];
};

export const followersColumns: TableColumn<ColumnProps['data'][number]>[] = [
  {
    label: 'USER',
    key: 'user',
    component: ({ data }) => <span>{data.userName}</span>,
  },
  {
    label: 'PNL',
    key: 'pnlOverCapital',
    component: ({ data }) => (
      <span
        className={classNames(
          data.returns > 0 ? 'text-green-success' : 'text-red-warning'
        )}
      >
        {data.returns > 0 && '+'}
        {formatTokenAmountCompact(data.returns)} USD
      </span>
    ),
  },
];
